import React from 'react';
import { useField } from 'formik';
import CheckboxToggle, { CheckboxToggleProps } from '@/components/ui/CheckboxToggle/CheckboxToggle.tsx';

interface FormikCheckboxToggleProps
	extends Omit<CheckboxToggleProps, 'checked' | 'onChange' | 'errorMessage' | 'touched'> {
	name: string;
	onValueChange?: (checked: boolean) => void;
}

const FormikCheckboxToggle: React.FC<FormikCheckboxToggleProps> = ({ name, onValueChange, ...props }) => {
	const [field, , helpers] = useField(name);
	const { value } = field;
	const { setValue, setTouched } = helpers;

	const handleChange = () => {
		const nextValue = !value;
		setValue(nextValue);
		setTouched(true);
		onValueChange?.(nextValue);
	};

	return (
		<CheckboxToggle
			{...props}
			checked={value}
			onChange={handleChange}
			name={name}
			className={props.className}
			style={props.style}
		/>
	);
};

export default FormikCheckboxToggle;
